import { modulesAdapter } from "@/module/adapters";

export default class QueriesController {
  #api;
  #paths;
  constructor(requestService, paths) {
    this.#api = requestService;
    this.#paths = paths;
  }

  async fetchModulesInfo() {
    try {
      const path = this.#paths.initialSetup.getModulesInfo;
      const { data } = await this.#api.Get(path);
      return modulesAdapter(data);
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain modules list.');
    }
  }
}
